var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDescargar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1784_7415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51609 9.5C6.71315 9.50034 6.90832 9.46172 7.0904 9.38639C7.27249 9.31105 7.43789 9.20047 7.57709 9.061L9.53659 7.1L8.82959 6.395L7.01309 8.212L7.00009 0H6.00009L6.01309 8.204L4.20309 6.394L3.49609 7.1L5.45559 9.0595C5.59464 9.19916 5.7599 9.30996 5.94189 9.38556C6.12389 9.46115 6.31902 9.50005 6.51609 9.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8V10.5C11.5 10.6326 11.4473 10.7598 11.3536 10.8536C11.2598 10.9473 11.1326 11 11 11H2C1.86739 11 1.74021 10.9473 1.64645 10.8536C1.55268 10.7598 1.5 10.6326 1.5 10.5V8H0.5V10.5C0.5 10.8978 0.658035 11.2794 0.93934 11.5607C1.22064 11.842 1.60218 12 2 12H11C11.3978 12 11.7794 11.842 12.0607 11.5607C12.342 11.2794 12.5 10.8978 12.5 10.5V8H11.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1784_7415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargar);
export default __webpack_public_path__ + "static/media/descargar.75b3f3b4e9e7f5432cae33fae0066126.svg";
export { ForwardRef as ReactComponent };